"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpViewInlineAssessment = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var i18n_1 = require("../../../i18n");
var react_i18next_1 = require("react-i18next");
var DpTags_1 = require("../../Assessment/Tags/DpTags");
var DpViewInlineAssessment_styled_1 = require("./DpViewInlineAssessment.styled");
var api_1 = require("../../../api");
var ViewItem = function (_a) {
    var item = _a.item;
    return (0, jsx_runtime_1.jsx)("div", { tabIndex: 0, children: item.title });
};
(0, i18n_1.initI18n)();
/**
 * This component renders the learnosity preview assessment functionality. Inline mode
 * Every event related to the component should be registered here.
 *
 * Reference: https://reference.learnosity.com/items-api
 */
var DpViewInlineAssessment = function (_a) {
    var as = _a.as, _b = _a.asProps, asProps = _b === void 0 ? {} : _b, items = _a.items, itemStandards = _a.itemStandards, signedRequest = _a.signedRequest, studentDetailsReady = _a.studentDetailsReady, children = _a.children, showStandards = _a.showStandards, _c = _a.singleLoad, singleLoad = _c === void 0 ? false : _c, _d = _a.isDiagnostic, isDiagnostic = _d === void 0 ? false : _d, _e = _a.showAllStandards, showAllStandards = _e === void 0 ? false : _e, _f = _a.loadLernosity, loadLernosity = _f === void 0 ? true : _f, assessmentTemplateTitle = _a.assessmentTemplateTitle, curriculum = _a.curriculum, sampleAnswersCallback = _a.sampleAnswersCallback, props = __rest(_a, ["as", "asProps", "items", "itemStandards", "signedRequest", "studentDetailsReady", "children", "showStandards", "singleLoad", "isDiagnostic", "showAllStandards", "loadLernosity", "assessmentTemplateTitle", "curriculum", "sampleAnswersCallback"]);
    var t = (0, react_i18next_1.useTranslation)('learnosity').t;
    var hasChildren = !!children;
    var _g = (0, react_1.useState)(false), loadsBlocked = _g[0], setLoadsBlocked = _g[1];
    var learnosityService = (0, react_1.useContext)(api_1.ServiceContext).learnosityService;
    var viewInlineReady = function () {
        if (studentDetailsReady) {
            studentDetailsReady();
        }
    };
    var Component = as || ViewItem;
    (0, react_1.useEffect)(function () {
        if (!loadsBlocked && loadLernosity) {
            learnosityService.initLernosityItemApi(signedRequest, {}, viewInlineReady, sampleAnswersCallback);
        }
        if (singleLoad)
            setLoadsBlocked(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: hasChildren
            ? children
            : items.map(function (item, index, _a) {
                var _b;
                var total = _a.length;
                var itemTag = item.isBranch
                    ? t('DpViewInlineAssessment.branch')
                    : t('DpViewInlineAssessment.core');
                var itemStandardsForItem = (_b = itemStandards === null || itemStandards === void 0 ? void 0 : itemStandards.filter(function (itemStandard) { return itemStandard.externalItemId === item.externalId; })) !== null && _b !== void 0 ? _b : [];
                return ((0, jsx_runtime_1.jsxs)(DpViewInlineAssessment_styled_1.StyledViewInlineAssessmentItem, { className: index ? 'page-break' : '', "data-testid": "view-inline-assessment-item", children: [(0, jsx_runtime_1.jsxs)("div", { className: "item-indicators", children: [isDiagnostic && ((0, jsx_runtime_1.jsx)("h2", { className: "h4", "aria-label": t('DpViewInlineAssessment.itemTag', {
                                        itemTag: itemTag,
                                        question: t('DpViewInlineAssessment.of', { question: index + 1, total: total }),
                                    }), children: (0, jsx_runtime_1.jsx)(DpTags_1.DpTags, { tags: [itemTag], maxToShow: 1 }) })), (0, jsx_runtime_1.jsx)("span", { className: "question-number", "aria-hidden": isDiagnostic, children: t('DpViewInlineAssessment.of', { question: index + 1, total: total }) })] }), (0, jsx_runtime_1.jsx)(Component
                        // @ts-ignore
                        , __assign({}, asProps, props, { item: item, showStandards: showStandards, showAllStandards: showAllStandards, assessmentTemplateTitle: assessmentTemplateTitle, curriculum: curriculum, itemStandards: itemStandardsForItem }), item.externalId)] }, item.externalId));
            }) }));
};
exports.DpViewInlineAssessment = DpViewInlineAssessment;
